<template>
<!-- drr：drag resize rotate -->
  <div>
     <div
      v-for="(item, index) in trackList"
      :key="item.id + '' + index"
      class="resizable-container"
    >
      <DraggableResizable
        class="resizable-style"
        class-name-handle="resizable-handle"
        ref="resizable"
        :w="item.width"
        :h="item.height"
        :x="item.nowXAxis"
        :y="item.nowYAxis"
        :angle="item.whirl"
        :minw="1"
        :minh="1"
        :parent="true"
        :active="!isSubmit && activeName === 'video'"
        :rotatable="false"
        :draggable="!isSubmit"
        :resizable="!isSubmit"
        @rotating="handleRotating"
        @resizing="handleResizing"
        @dragging="handleDragging"
        @dragstop="handleDragStop"
        @resizestop="handleResizeStop"
        @activated="handleActive(index)"

      >
         <video
          ref="drrTarget"
          class="picture-video"
          :muted ="!videoPlay"
          :poster="item.resourceIcon"
          :src="item.resourceUrl"
          @mousedown="handleResizeClick"
        ></video>
      </DraggableResizable>
    </div>
  </div>
</template>
<script>
import DraggableResizable from 'vue-drr'
import { mapState } from 'vuex'
export default {
  components: {
    DraggableResizable
  },
  props: {
    keyCode: {
      type: Number,
      default: null
    },
    trackIndex: {
      type: Number,
      default: 0
    },
    videoPlay: {
      type: Boolean,
      default: false
    },
    isTextEdit: {
      type: Boolean,
      default: false
    },
    isSubmit: {
      type: Boolean,
      default: false
    },
    trackList: {
      type: Array,
      default: () => []
    },
    scale: { // 保存/提交剪辑页面播放区域与在线剪辑播放区域的比例
      type: Object,
      default: function () {}
    }
  },
  computed: {
    ...mapState({
      activeName: state => state.activeName,
      selected: state => state.selected
    }),
    realScale() {
      // if (this.scale && this.scale.width) {
      //   return this.scale
      // } else {
      //   return {
      //     width: 1,
      //     height: 1
      //   }
      // }
      return {
        width: 1,
        height: 1
      }
    }
  },
  methods: {
    // 鼠标按下事件
    handleResizeClick(e) {
    },
    // 旋转

    handleRotating(angle) {
      if (this.videoPlay) {
        this.$emit('video-pause')
      }
      const type = 'video'
      this.$store.commit('drrRotating', { angle: 0, type })
    },
    // 缩放
    handleResizing(left, top, width, height) {
      if (this.videoPlay) {
        this.$emit('video-pause')
      }
      const rect = {
        left: left,
        top: top,
        width: width,
        height: height
      }
      this.handleDrrResizing(this.keyCode, rect, this)
      this.$store.commit('drrResizing', { keyCode: this.keyCode, rect: rect, vm: this, type: 'video' })
    },
    handleDragging() {
      if (this.videoPlay) {
        this.$emit('video-pause')
      }
    },
    // 操作结束
    handleDragStop(left, top) {
      this.$store.commit('drrDragStop', { left: left, top: top, vm: this, type: 'video' })
    },
    handleResizeStop(left, top, width, height) {
      this.$store.commit('drrResizeStop', { left: left, top: top, width: width, height: height, type: 'video' })
    },
    handleActive(index) {
      if (this.isSubmit) {
        // 若处于保存/提交剪辑页面 并不允许激活
        return false
      }
      this.$store.commit('drrActive', {
        activeTarget: 'video',
        list: 'videoTrackList',
        playingName: 'playingVideo',
        vm: this
      })
      const e = document.querySelector('#videoTrack')
      this.$store.commit('trackBlockSelect', { e: e, index: index, trackIndex: this.trackIndex, list: 'videoTrackList' })
    },
    handleDrrResizing() {

    }
  }
}
</script>
<style lang="stylus" scoped>
.resizable-container
  position absolute
  top 0px
  width 100%
  height 100%
  overflow hidden
.resizable-style
  position absolute
  z-index 2
  .el-image
  video
    width inherit
    height inherit
.picture-video
  object-fit fill
</style>
